import { useTranslations } from 'next-intl';
import { BentoHeading, BentoPara } from './StyleConstants';
import styles from './MoveCard.module.css';

const GraphSvg = (
  <svg
    width="471"
    height="143"
    viewBox="0 0 471 143"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 137.5C0 136.672 0.671573 136 1.5 136C2.32843 136 3 136.672 3 137.5V143H0V137.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M4 130.5C4 129.672 4.67157 129 5.5 129C6.32843 129 7 129.672 7 130.5V143H4V130.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M8 125.5C8 124.672 8.67157 124 9.5 124C10.3284 124 11 124.672 11 125.5V143H8V125.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M12 132.5C12 131.672 12.6716 131 13.5 131C14.3284 131 15 131.672 15 132.5V143H12V132.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M16 97.5C16 96.6716 16.6716 96 17.5 96C18.3284 96 19 96.6716 19 97.5V143H16V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M20 62.5C20 61.6716 20.6716 61 21.5 61C22.3284 61 23 61.6716 23 62.5V143H20V62.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M24 121.5C24 120.672 24.6716 120 25.5 120C26.3284 120 27 120.672 27 121.5V143H24V121.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M28 121.5C28 120.672 28.6716 120 29.5 120C30.3284 120 31 120.672 31 121.5V143H28V121.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M32 97.5C32 96.6716 32.6716 96 33.5 96C34.3284 96 35 96.6716 35 97.5V143H32V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M36 86.5C36 85.6716 36.6716 85 37.5 85C38.3284 85 39 85.6716 39 86.5V143H36V86.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M40 118.5C40 117.672 40.6716 117 41.5 117C42.3284 117 43 117.672 43 118.5V143H40V118.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M44 71.5C44 70.6716 44.6716 70 45.5 70C46.3284 70 47 70.6716 47 71.5V143H44V71.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M48 97.5C48 96.6716 48.6716 96 49.5 96C50.3284 96 51 96.6716 51 97.5V143H48V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M52 116.5C52 115.672 52.6716 115 53.5 115C54.3284 115 55 115.672 55 116.5V143H52V116.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M56 128.5C56 127.672 56.6716 127 57.5 127C58.3284 127 59 127.672 59 128.5V143H56V128.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M60 71.5C60 70.6716 60.6716 70 61.5 70C62.3284 70 63 70.6716 63 71.5V143H60V71.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M64 36.5C64 35.6716 64.6716 35 65.5 35C66.3284 35 67 35.6716 67 36.5V143H64V36.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M68 97.5C68 96.6716 68.6716 96 69.5 96C70.3284 96 71 96.6716 71 97.5V143H68V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M72 100.5C72 99.6716 72.6716 99 73.5 99C74.3284 99 75 99.6716 75 100.5V143H72V100.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M76 102.5C76 101.672 76.6716 101 77.5 101C78.3284 101 79 101.672 79 102.5V143H76V102.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M80 97.5C80 96.6716 80.6716 96 81.5 96C82.3284 96 83 96.6716 83 97.5V143H80V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M84 118.5C84 117.672 84.6716 117 85.5 117C86.3284 117 87 117.672 87 118.5V143H84V118.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M88 118.5C88 117.672 88.6716 117 89.5 117C90.3284 117 91 117.672 91 118.5V143H88V118.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M92 83.5C92 82.6716 92.6716 82 93.5 82C94.3284 82 95 82.6716 95 83.5V143H92V83.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M96 83.5C96 82.6716 96.6716 82 97.5 82C98.3284 82 99 82.6716 99 83.5V143H96V83.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M100 4.5C100 3.67157 100.672 3 101.5 3C102.328 3 103 3.67157 103 4.5V143H100V4.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M104 53.5C104 52.6716 104.672 52 105.5 52C106.328 52 107 52.6716 107 53.5V143H104V53.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M108 97.5C108 96.6716 108.672 96 109.5 96C110.328 96 111 96.6716 111 97.5V143H108V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M112 97.5C112 96.6716 112.672 96 113.5 96C114.328 96 115 96.6716 115 97.5V143H112V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M116 41.5C116 40.6716 116.672 40 117.5 40C118.328 40 119 40.6716 119 41.5V143H116V41.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M120 50.5C120 49.6716 120.672 49 121.5 49C122.328 49 123 49.6716 123 50.5V143H120V50.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M124 1.5C124 0.671575 124.672 0 125.5 0C126.328 0 127 0.671573 127 1.5V143H124V1.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M128 50.5C128 49.6716 128.672 49 129.5 49C130.328 49 131 49.6716 131 50.5V143H128V50.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M132 50.5C132 49.6716 132.672 49 133.5 49C134.328 49 135 49.6716 135 50.5V143H132V50.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M136 114.5C136 113.672 136.672 113 137.5 113C138.328 113 139 113.672 139 114.5V143H136V114.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M140 100.5C140 99.6716 140.672 99 141.5 99C142.328 99 143 99.6716 143 100.5V143H140V100.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M144 114.5C144 113.672 144.672 113 145.5 113C146.328 113 147 113.672 147 114.5V143H144V114.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M148 86.5C148 85.6716 148.672 85 149.5 85C150.328 85 151 85.6716 151 86.5V143H148V86.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M152 83.5C152 82.6716 152.672 82 153.5 82C154.328 82 155 82.6716 155 83.5V143H152V83.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M156 4.5C156 3.67157 156.672 3 157.5 3C158.328 3 159 3.67157 159 4.5V143H156V4.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M160 64.5C160 63.6716 160.672 63 161.5 63C162.328 63 163 63.6716 163 64.5V143H160V64.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M164 29.5C164 28.6716 164.672 28 165.5 28C166.328 28 167 28.6716 167 29.5V143H164V29.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M168 50.5C168 49.6716 168.672 49 169.5 49C170.328 49 171 49.6716 171 50.5V143H168V50.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M172 50.5C172 49.6716 172.672 49 173.5 49C174.328 49 175 49.6716 175 50.5V143H172V50.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M176 97.5C176 96.6716 176.672 96 177.5 96C178.328 96 179 96.6716 179 97.5V143H176V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M180 97.5C180 96.6716 180.672 96 181.5 96C182.328 96 183 96.6716 183 97.5V143H180V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M184 128.5C184 127.672 184.672 127 185.5 127C186.328 127 187 127.672 187 128.5V143H184V128.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M188 128.5C188 127.672 188.672 127 189.5 127C190.328 127 191 127.672 191 128.5V143H188V128.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M192 50.5C192 49.6716 192.672 49 193.5 49C194.328 49 195 49.6716 195 50.5V143H192V50.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M196 86.5C196 85.6716 196.672 85 197.5 85C198.328 85 199 85.6716 199 86.5V143H196V86.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M200 83.5C200 82.6716 200.672 82 201.5 82C202.328 82 203 82.6716 203 83.5V143H200V83.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M204 97.5C204 96.6716 204.672 96 205.5 96C206.328 96 207 96.6716 207 97.5V143H204V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M208 97.5C208 96.6716 208.672 96 209.5 96C210.328 96 211 96.6716 211 97.5V143H208V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M212 137.5C212 136.672 212.672 136 213.5 136C214.328 136 215 136.672 215 137.5V143H212V137.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M216 130.5C216 129.672 216.672 129 217.5 129C218.328 129 219 129.672 219 130.5V143H216V130.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M220 125.5C220 124.672 220.672 124 221.5 124C222.328 124 223 124.672 223 125.5V143H220V125.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M224 132.5C224 131.672 224.672 131 225.5 131C226.328 131 227 131.672 227 132.5V143H224V132.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M228 97.5C228 96.6716 228.672 96 229.5 96C230.328 96 231 96.6716 231 97.5V143H228V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M232 62.5C232 61.6716 232.672 61 233.5 61C234.328 61 235 61.6716 235 62.5V143H232V62.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M236 121.5C236 120.672 236.672 120 237.5 120C238.328 120 239 120.672 239 121.5V143H236V121.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M240 121.5C240 120.672 240.672 120 241.5 120C242.328 120 243 120.672 243 121.5V143H240V121.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M244 97.5C244 96.6716 244.672 96 245.5 96C246.328 96 247 96.6716 247 97.5V143H244V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M248 86.5C248 85.6716 248.672 85 249.5 85C250.328 85 251 85.6716 251 86.5V143H248V86.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M252 118.5C252 117.672 252.672 117 253.5 117C254.328 117 255 117.672 255 118.5V143H252V118.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M256 71.5C256 70.6716 256.672 70 257.5 70C258.328 70 259 70.6716 259 71.5V143H256V71.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M260 97.5C260 96.6716 260.672 96 261.5 96C262.328 96 263 96.6716 263 97.5V143H260V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M264 116.5C264 115.672 264.672 115 265.5 115C266.328 115 267 115.672 267 116.5V143H264V116.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M268 128.5C268 127.672 268.672 127 269.5 127C270.328 127 271 127.672 271 128.5V143H268V128.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M272 71.5C272 70.6716 272.672 70 273.5 70C274.328 70 275 70.6716 275 71.5V143H272V71.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M276 36.5C276 35.6716 276.672 35 277.5 35C278.328 35 279 35.6716 279 36.5V143H276V36.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M280 97.5C280 96.6716 280.672 96 281.5 96C282.328 96 283 96.6716 283 97.5V143H280V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M284 100.5C284 99.6716 284.672 99 285.5 99C286.328 99 287 99.6716 287 100.5V143H284V100.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M288 102.5C288 101.672 288.672 101 289.5 101C290.328 101 291 101.672 291 102.5V143H288V102.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M292 97.5C292 96.6716 292.672 96 293.5 96C294.328 96 295 96.6716 295 97.5V143H292V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M296 118.5C296 117.672 296.672 117 297.5 117C298.328 117 299 117.672 299 118.5V143H296V118.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M300 118.5C300 117.672 300.672 117 301.5 117C302.328 117 303 117.672 303 118.5V143H300V118.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M304 83.5C304 82.6716 304.672 82 305.5 82C306.328 82 307 82.6716 307 83.5V143H304V83.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M308 83.5C308 82.6716 308.672 82 309.5 82C310.328 82 311 82.6716 311 83.5V143H308V83.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M312 4.5C312 3.67157 312.672 3 313.5 3C314.328 3 315 3.67157 315 4.5V143H312V4.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M316 53.5C316 52.6716 316.672 52 317.5 52C318.328 52 319 52.6716 319 53.5V143H316V53.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M320 97.5C320 96.6716 320.672 96 321.5 96C322.328 96 323 96.6716 323 97.5V143H320V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M324 97.5C324 96.6716 324.672 96 325.5 96C326.328 96 327 96.6716 327 97.5V143H324V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M328 41.5C328 40.6716 328.672 40 329.5 40C330.328 40 331 40.6716 331 41.5V143H328V41.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M332 50.5C332 49.6716 332.672 49 333.5 49C334.328 49 335 49.6716 335 50.5V143H332V50.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M336 1.5C336 0.671575 336.672 0 337.5 0C338.328 0 339 0.671573 339 1.5V143H336V1.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M340 50.5C340 49.6716 340.672 49 341.5 49C342.328 49 343 49.6716 343 50.5V143H340V50.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M344 50.5C344 49.6716 344.672 49 345.5 49C346.328 49 347 49.6716 347 50.5V143H344V50.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M348 114.5C348 113.672 348.672 113 349.5 113C350.328 113 351 113.672 351 114.5V143H348V114.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M352 100.5C352 99.6716 352.672 99 353.5 99C354.328 99 355 99.6716 355 100.5V143H352V100.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M424 143C424 142.448 424.448 142 425 142H426C426.552 142 427 142.448 427 143H424Z"
      fill="#D9D9D9"
    />
    <path
      d="M356 114.5C356 113.672 356.672 113 357.5 113C358.328 113 359 113.672 359 114.5V143H356V114.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M428 143C428 142.448 428.448 142 429 142H430C430.552 142 431 142.448 431 143H428Z"
      fill="#D9D9D9"
    />
    <path
      d="M360 86.5C360 85.6716 360.672 85 361.5 85C362.328 85 363 85.6716 363 86.5V143H360V86.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M432 143C432 142.448 432.448 142 433 142H434C434.552 142 435 142.448 435 143H432Z"
      fill="#D9D9D9"
    />
    <path
      d="M364 83.5C364 82.6716 364.672 82 365.5 82C366.328 82 367 82.6716 367 83.5V143H364V83.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M436 143C436 142.448 436.448 142 437 142H438C438.552 142 439 142.448 439 143H436Z"
      fill="#D9D9D9"
    />
    <path
      d="M368 4.5C368 3.67157 368.672 3 369.5 3C370.328 3 371 3.67157 371 4.5V143H368V4.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M440 143C440 142.448 440.448 142 441 142H442C442.552 142 443 142.448 443 143H440Z"
      fill="#D9D9D9"
    />
    <path
      d="M372 64.5C372 63.6716 372.672 63 373.5 63C374.328 63 375 63.6716 375 64.5V143H372V64.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M444 143C444 142.448 444.448 142 445 142H446C446.552 142 447 142.448 447 143H444Z"
      fill="#D9D9D9"
    />
    <path
      d="M376 29.5C376 28.6716 376.672 28 377.5 28C378.328 28 379 28.6716 379 29.5V143H376V29.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M448 143C448 142.448 448.448 142 449 142H450C450.552 142 451 142.448 451 143H448Z"
      fill="#D9D9D9"
    />
    <path
      d="M380 50.5C380 49.6716 380.672 49 381.5 49C382.328 49 383 49.6716 383 50.5V143H380V50.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M452 143C452 142.448 452.448 142 453 142H454C454.552 142 455 142.448 455 143H452Z"
      fill="#D9D9D9"
    />
    <path
      d="M384 50.5C384 49.6716 384.672 49 385.5 49C386.328 49 387 49.6716 387 50.5V143H384V50.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M456 143C456 142.448 456.448 142 457 142H458C458.552 142 459 142.448 459 143H456Z"
      fill="#D9D9D9"
    />
    <path
      d="M388 97.5C388 96.6716 388.672 96 389.5 96C390.328 96 391 96.6716 391 97.5V143H388V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M460 143C460 142.448 460.448 142 461 142H462C462.552 142 463 142.448 463 143H460Z"
      fill="#D9D9D9"
    />
    <path
      d="M392 97.5C392 96.6716 392.672 96 393.5 96C394.328 96 395 96.6716 395 97.5V143H392V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M464 143C464 142.448 464.448 142 465 142H466C466.552 142 467 142.448 467 143H464Z"
      fill="#D9D9D9"
    />
    <path
      d="M396 128.5C396 127.672 396.672 127 397.5 127C398.328 127 399 127.672 399 128.5V143H396V128.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M468 143C468 142.448 468.448 142 469 142H470C470.552 142 471 142.448 471 143H468Z"
      fill="#D9D9D9"
    />
    <path
      d="M400 128.5C400 127.672 400.672 127 401.5 127C402.328 127 403 127.672 403 128.5V143H400V128.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M404 50.5C404 49.6716 404.672 49 405.5 49C406.328 49 407 49.6716 407 50.5V143H404V50.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M408 86.5C408 85.6716 408.672 85 409.5 85C410.328 85 411 85.6716 411 86.5V143H408V86.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M412 83.5C412 82.6716 412.672 82 413.5 82C414.328 82 415 82.6716 415 83.5V143H412V83.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M416 97.5C416 96.6716 416.672 96 417.5 96C418.328 96 419 96.6716 419 97.5V143H416V97.5Z"
      fill="#D9D9D9"
    />
    <path
      d="M420 97.5C420 96.6716 420.672 96 421.5 96C422.328 96 423 96.6716 423 97.5V143H420V97.5Z"
      fill="#D9D9D9"
    />
  </svg>
);

export const MoveCard = ({ className }: { className?: string }) => {
  const t = useTranslations('ring');
  return (
    <div className={`${styles.root} container${className ? ` ${className}` : ''}`}>
      <BentoHeading>{t('ring.bentoSection.moveCard.head')}</BentoHeading>
      <BentoPara>
        <b>{t('ring.THE_MOVEMENT_INDEX')}</b>{' '}
        {t('ring.bentoSection.moveCard.desc')}
      </BentoPara>

      <div className={styles['graph-content']}>
        <div className={styles.info}>
          <div className={styles.element}>
            <p className={styles.title}>{t('ring.THE_MOVEMENT_INDEX')}</p>
            <p className={styles['description-num']}>84</p>
          </div>
          <div className={styles.element}>
            <p className={styles.title}> {t('ring.STEPS')}</p>
            <p className={styles['description-num']}>11812</p>
          </div>
          <div className={styles.element}>
            <p className={styles.title}> {t('ring.CALORIES_BURNT')}</p>
            <p className={styles['description-num']}>2786</p>
          </div>
        </div>
        {GraphSvg}
      </div>
    </div>
  );
};
